import React from 'react';

// Material UI
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// Theme
import { sectionDarkColor } from '../../../lib/theme';

// Reading measure for the section's content: `medium` suits a single-column
// form or list; `large` is for multi-column layouts that need the extra width.
const CONTENT_MAX_WIDTH = {
  medium: '800px',
  large: '1200px',
};

interface IAccordionSectionProps {
  title: React.ReactNode;
  defaultExpanded?: boolean;
  // Mount the children on first expand — for a section whose content queries on mount and
  // would otherwise pay for itself on every visit that never opens it.
  unmountOnExit?: boolean;
  size?: keyof typeof CONTENT_MAX_WIDTH;
  children: React.ReactNode;
}

export const AccordionSection: React.FC<IAccordionSectionProps> = ({ title, defaultExpanded, unmountOnExit, size = 'medium', children }) => (
  <Accordion
    defaultExpanded={defaultExpanded}
    TransitionProps={unmountOnExit ? { unmountOnExit: true } : undefined}
    style={{ background: sectionDarkColor }}
  >
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      {/* AccordionSummary is a role="button", which flattens child headings for
          assistive tech — the h2 is a DOM-outline hint, not an announced heading. */}
      <Typography component="h2" style={{ fontWeight: 'bold' }}>{title}</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <div style={{ width: '100%', maxWidth: CONTENT_MAX_WIDTH[size] }}>{children}</div>
    </AccordionDetails>
  </Accordion>
);
